import React from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { publishDataset } from 'action/dataset'
import PropTypes from 'prop-types'
import confirmModal from 'view/component/confirm-modal'
import { startCase } from 'lodash'
import { Button } from 'antd'
import styles from './styles'

const generateModalText = (title, publishText) => ({
  decide: {
    content: '',
    title: `Are you sure you want to ${publishText} ${title}?`
  },

  outcome: {
    content: {
      error: 'Please try Again',
      success: `${title} has been successfully ${publishText}ed`
    },
    title: {
      error: `There has been an issue ${publishText}ing ${title}`,
      success: `Dataset ${publishText}ed`
    }
  }
})

const PublishDataset = ({ publishDataset, dataset: { uuid, title, published: isPublished, is_draft: isDraft }, pagination }) => {
  const publishText = isPublished ? 'unpublish' : 'publish'

  const handleSubmit = () => publishDataset(uuid)

  const { decide, outcome } = generateModalText(title, publishText)

  return (
    <Button
      className={styles.menu_item}
      disabled={isDraft}
      onClick={() => confirmModal(handleSubmit, decide, outcome)}
      type='text'
    >{`${startCase(publishText)} Dataset`}</Button>
  )
}

PublishDataset.propTypes = {
  dataset: PropTypes.object,
  pagination: PropTypes.object,
  publishDataset: PropTypes.func
}

const mapDispatchToProps = (dispatch) => ({
  publishDataset: bindActionCreators(publishDataset, dispatch)
})

const mapStateToProps = (state) => ({
  pagination: state.dataset.pagination
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PublishDataset)
